import { Trans } from '@gamiphy/react-i18n';
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';
import { UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import CloseIcon from '@mui/icons-material/Close';
import { AppDtoLanguageEnum } from '@coretava/api/core-service';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import { useMobile } from '@gamiphy/loyalty-station-desktop/utils/mobile';
import { getButtonGradiant } from '../utils';
import { Popup } from '../../popup';
import checkoutDesktopES from '../assets/checkoutDesktopES.png';
import checkoutDesktopPT from '../assets/checkoutDesktopPT.png';
import checkoutMobileES from '../assets/checkoutMobileES.png';
import checkoutMobilePT from '../assets/checkoutMobilePT.png';
import sideArow from '../assets/leftArrow.png';
import upArrow from '../assets/upArrow.png';

const CheckoutExample: React.FC = () => {
  const isMobile = useMobile();

  const checkoutExample = React.useMemo(() => {
    switch (AppStore.app.language) {
      case AppDtoLanguageEnum.Es:
        return isMobile ? checkoutMobileES : checkoutDesktopES;
      default:
        return isMobile ? checkoutMobilePT : checkoutDesktopPT;
    }
  }, [AppStore.app, isMobile]);

  return (
    <Popup
      fullWidth
      open={UiStore.checkoutExampleOpen}
      slotProps={{ paper: { sx: { maxWidth: 786 } } }}
      onClose={() => UiStore.closeCheckoutExample()}
    >
      <DialogTitle sx={{ p: isMobile ? 2.5 : 3, pb: 0 }}>
        <Grid
          container
          alignItems="flex-start"
          justifyContent="space-between"
          wrap="nowrap"
        >
          <Grid>
            <Typography fontWeight={600} fontSize={isMobile ? 20 : 24}>
              <Trans
                i18nKey="redeem.discountCodeApplied.howApplied"
                defaults="How Your Gift Card Balance is Applied"
              />
            </Typography>
            <Typography fontSize={isMobile ? 14 : 18} fontWeight={500} color="#B8B8B8">
              <Trans
                i18nKey="redeem.discountCodeApplied.checkScreenshot"
                defaults="Check the screenshot down below"
              />
            </Typography>
          </Grid>
          <Grid>
            <IconButton
              onClick={() => UiStore.closeCheckoutExample()}
              sx={{
                bgcolor: '#0000000D',
              }}
            >
              <CloseIcon fontSize="large" />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent sx={{
        display: 'flex',
        alignItems: 'center',
        px: isMobile ? 1.6 : 7,
        py: (th) => `${th.spacing(3.1)} !important`,
      }}
      >
        <Grid container rowSpacing={1} columnSpacing={4} alignItems="center">
          <Grid size={isMobile ? 12 : 8} position="relative">
            <Box component="img" src={checkoutExample} width="100%" />
            {!isMobile && (
              <Box component="img" src={sideArow} position="absolute" bottom="42%" right={-28} />
            )}
            {isMobile && (
              <Box
                component="img"
                src={upArrow}
                position="absolute"
                sx={{
                  top: '48%',
                  height: '55%',
                  width: '12px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                }}
              />
            )}
          </Grid>
          <Grid size={isMobile ? 12 : 4}>
            <Box sx={{ bgcolor: '#DA604F17' }} borderRadius={1.2} p={2}>
              <Typography fontSize={14} fontWeight={600} color="#DA604F">
                <Trans
                  i18nKey="redeem.discountCodeApplied.screenshot.description"
                  defaults="Your gift card will  be automatically applied as a discount at checkout."
                />
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ p: isMobile ? 2.5 : 3, ...isMobile && { pt: 0 } }}>
        <Button
          fullWidth
          variant="contained"
          sx={{ borderRadius: '100px', background: (th) => getButtonGradiant(th.palette.primary.main) }}
          onClick={() => UiStore.closeCheckoutExample()}
        >
          <Trans
            i18nKey="go.back"
            defaults="Go Back"
          />
        </Button>
      </DialogActions>
    </Popup>
  );
};

export default observer(CheckoutExample);
